import { Stack, Typography } from '@mui/material'
import { DataGridPro, GridColDef } from '@mui/x-data-grid-pro'
import { getPreferredName } from 'shared/utils'

export interface RosterCandidateFavoritesProps {
    clientFavorites: RosterCandidateFavoritesRow[]
}

export interface RosterCandidateFavoritesRow {
    id: string
    user?: {
        firstName?: string
        nickname?: string
        lastName?: string
    }
    updatedAt?: Date
    createdAt?: Date
}

const columns: GridColDef<RosterCandidateFavoritesRow>[] = [
    {
        field: 'name',
        headerName: 'Client Name',
        sortable: false,
        flex: 1,
        renderCell: ({ row }) => {
            const user = row.user
            return (
                <Stack height="100%" justifyContent={'center'}>
                    <Typography noWrap variant="body2">
                        {getPreferredName({
                            firstName: user?.firstName,
                            nickname: user?.nickname,
                        })}
                    </Typography>
                </Stack>
            )
        },
    },
    {
        field: 'date',
        headerName: 'Date',
        sortable: false,
        flex: 1,
        renderCell: ({ row }) => {
            const date = row.updatedAt ?? row.createdAt
            return (
                <Stack height="100%" justifyContent={'center'}>
                    <Typography noWrap variant="body2">
                        {date
                            ? `${new Date(date).toLocaleDateString()}, ${new Date(
                                  date
                              ).toLocaleTimeString('en-US', {
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  hour12: true,
                              })}`
                            : '-'}
                    </Typography>
                </Stack>
            )
        },
    },
]

const RosterCandidateFavorites: React.FC<RosterCandidateFavoritesProps> = ({
    clientFavorites,
}) => {
    return (
        <DataGridPro
            columns={columns}
            rows={clientFavorites}
            getRowId={(row) => `${row.id}`}
            disableColumnMenu
            hideFooter
            disableColumnResize
        />
    )
}

export default RosterCandidateFavorites
